module.exports = __webpack_public_path__ + "media/images/yahoo_round_primary-892bf7f0.png";